export const TURNSTILE_SIMULATION_CHALLENGE_MODE = "challenge";
export const TURNSTILE_SIMULATION_FAIL_MODE = "fail";

export type TurnstileSimulationMode = typeof TURNSTILE_SIMULATION_CHALLENGE_MODE | typeof TURNSTILE_SIMULATION_FAIL_MODE;

// Cloudflare public test key that always forces an interactive challenge
export const TURNSTILE_FORCE_CHALLENGE_SITE_KEY = "3x00000000000000000000FF";

export const getTurnstileSimulationMode = (storageKey: string | undefined): TurnstileSimulationMode | null => {
    if (!storageKey || typeof window === "undefined") {
        return null;
    }

    try {
        const mode = window.localStorage.getItem(storageKey);

        if (mode === TURNSTILE_SIMULATION_CHALLENGE_MODE || mode === TURNSTILE_SIMULATION_FAIL_MODE) {
            return mode;
        }
    } catch {
        return null;
    }

    return null;
};
export const TURNSTILE_SIMULATION_CHALLENGE_MODE = "challenge";
export const TURNSTILE_SIMULATION_FAIL_MODE = "fail";

export type TurnstileSimulationMode = typeof TURNSTILE_SIMULATION_CHALLENGE_MODE | typeof TURNSTILE_SIMULATION_FAIL_MODE;

// Cloudflare public test key that always forces an interactive challenge
export const TURNSTILE_FORCE_CHALLENGE_SITE_KEY = "3x00000000000000000000FF";

export const getTurnstileSimulationMode = (storageKey: string | undefined): TurnstileSimulationMode | null => {
    if (!storageKey || typeof window === "undefined") {
        return null;
    }

    try {
        const mode = window.localStorage.getItem(storageKey);

        if (mode === TURNSTILE_SIMULATION_CHALLENGE_MODE || mode === TURNSTILE_SIMULATION_FAIL_MODE) {
            return mode;
        }
    } catch {
        return null;
    }

    return null;
};
